import * as React from 'react';

import Context from './context';

const UnsavedChangesProvider: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const [hasUnsavedChanges, setUnsavedChanges] = React.useState(false);
  return <Context.Provider value={{ hasUnsavedChanges, setUnsavedChanges }}>{children}</Context.Provider>;
};

export default UnsavedChangesProvider;
